<template>
  <div>
    <PageHeader
      :title="`${title} ${is_free ? '(สินค้าฟรี)' : ''}`"
      :items="items"
    />
    <div class="row mb-8">
      <div class="col-xl-10 col-lg-9 col-md-9">
        <!-- new product information-->
        <div
          v-if="is_view && product_register_draft_id"
          class="card"
          ref="NewProductInformation"
        >
          <NewProductInformation
            v-model="collapseStateNewProductInformation"
            :id="product_register_draft_id"
          ></NewProductInformation>
        </div>
        <!-- vendor information -->
        <div class="card" ref="VendorInformation">
          <VendorComponent
            v-model="registerOperatorModel.vendorComponentModel"
            :is_view="is_view"
          >
          </VendorComponent>
        </div>
        <!-- basic information -->
        <div class="card" ref="BasicInformation">
          <BasicComponent
            v-model="registerOperatorModel.basicComponentModel"
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
            :is_free="is_free"
            :is_view="is_view"
            :vendor_code="registerOperatorModel.vendorComponentModel.model.code"
          >
          </BasicComponent>
        </div>
        <!-- Product Detail -->
        <div class="card" ref="ProductDetailComponent">
          <ProductDetailComponent
            ref="ProductDetail"
            v-model="registerOperatorModel.productDetailComponentModel"
            :basicModel="registerOperatorModel.basicComponentModel.model"
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
            :discount_rate_1="
              registerOperatorModel.vendorComponentModel.model.discount_rate_1
            "
            :is_free="is_free"
            :is_view="is_view"
            :vat_rate="
              registerOperatorModel.vendorComponentModel.model.vat_rate
            "
            :business_unit="
              registerOperatorModel.basicComponentModel.model.business_unit
            "
          >
          </ProductDetailComponent>
        </div>
        <!-- Image Management -->
        <div class="card" ref="ImageManagement">
          <ImageComponent
            v-model="registerOperatorModel.imageComponentModel"
            :documentId="product_register_draft_id"
            :skus="registerOperatorModel.productDetailComponentModel.model.skus"
            :is_view="is_view"
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
          >
          </ImageComponent>
        </div>
        <!-- Product Content -->
        <div class="card" ref="ProductContentComponent">
          <ProductContentComponent
            v-model="registerOperatorModel.productContentComponentModel"
            :is_free="is_free"
            :is_view="is_view"
          >
          </ProductContentComponent>
        </div>
        <!-- Product AttributeComponent -->
        <div class="card" ref="ProductAttribute">
          <AttributeComponent
            v-model="registerOperatorModel.attributeComponentModel"
            :is_free="is_free"
            :hybridCategoryId="
              registerOperatorModel.basicComponentModel.model.categories.some(
                s => s.type == 'Hybrid'
              )
                ? registerOperatorModel.basicComponentModel.model.categories.find(
                    f => f.type == 'Hybrid'
                  ).id
                : ''
            "
            :is_view="is_view"
          >
          </AttributeComponent>
        </div>
        <!-- Shipment Detail -->
        <div class="card" ref="ShipmentDetail">
          <ShipmentComponent
            v-model="registerOperatorModel.shipmentComponentModel"
            :skus="
              this.registerOperatorModel.productDetailComponentModel.model.skus
            "
            :lead_time="
              registerOperatorModel.vendorComponentModel.model.lead_time
            "
            :is_free="is_free"
            :inventoryId="
              registerOperatorModel.basicComponentModel.model.categories &&
              registerOperatorModel.basicComponentModel.model.categories.some(
                s => s.type === 'Inventory'
              )
                ? registerOperatorModel.basicComponentModel.model.categories.find(
                    s => s.type === 'Inventory'
                  ).id
                : ''
            "
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
            :is_view="is_view"
          >
          </ShipmentComponent>
        </div>
        <!-- Payment Method -->
        <div
          v-if="userInfo.user_type === 'Operator'"
          class="card"
          ref="PaymentMethod"
        >
          <PaymentMethodComponent
            v-model="registerOperatorModel.paymentMethodComponentModel"
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
            :is_view="is_view"
            :business_unit="
              registerOperatorModel.basicComponentModel.model.business_unit
            "
            :product_status="
              registerOperatorModel.productDetailComponentModel.model.skus
                .length > 0
                ? registerOperatorModel.productDetailComponentModel.model
                    .skus[0].skuModel.product_status.inventory
                : ''
            "
          >
          </PaymentMethodComponent>
        </div>
        <!-- Channel -->
        <div
          v-if="userInfo.user_type === 'Operator'"
          class="card"
          ref="Channel"
        >
          <ChannelComponent
            v-model="registerOperatorModel.channelComponentModel"
            :is_view="is_view"
            :business_unit="
              registerOperatorModel.basicComponentModel.model.business_unit
            "
          >
          </ChannelComponent>
        </div>
        <!-- Cluster -->
        <!-- <div
          v-if="userInfo.user_type === 'Operator'"
          class="card"
          ref="Cluster"
        >
          <ClusterComponent
            v-model="registerOperatorModel.clusterComponentModel"
             :is_view="is_view"
          >
          </ClusterComponent>
        </div> -->
        <!-- Catalog -->
        <!-- <div
          v-if="userInfo.user_type === 'Operator'"
          class="card"
          ref="Catalog"
        >
          <CatalogComponent
            v-model="registerOperatorModel.catalogComponentModel"
            :is_view="is_view"
          >
          </CatalogComponent>
        </div> -->
        <!-- Inventory -->
        <div
          v-if="userInfo.user_type === 'Operator'"
          class="card"
          ref="Inventory"
        >
          <InventoryComponent
            v-model="registerOperatorModel.inventoryComponentModel"
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
            :is_view="is_view"
          >
          </InventoryComponent>
        </div>
        <!-- Other Setting -->
        <div class="card" ref="OtherSetting">
          <OtherComponent
            v-model="registerOperatorModel.otherComponentModel"
            :is_consignment="
              registerOperatorModel.vendorComponentModel.model.is_consignment
            "
            :vendor_type="
              registerOperatorModel.vendorComponentModel.model.vendor_type
            "
            :is_import="
              registerOperatorModel.vendorComponentModel.model.is_import
            "
            :brand_id="registerOperatorModel.basicComponentModel.model.brand.id"
            :is_free="is_free"
            :is_view="is_view"
            :skus="
              this.registerOperatorModel.productDetailComponentModel.model.skus
            "
          >
          </OtherComponent>
        </div>
        <!-- Document -->
        <div class="card" ref="Document">
          <DocumentComponent
            v-model="registerOperatorModel.documentComponentModel"
            :is_view="is_view"
          >
          </DocumentComponent>
        </div>
        <div class="row pt-4">
          <div class="col text-left">
            <button type="button" @click="onBack()" class="btn btn-light">
              <i class="bx bx-arrow-back" />
              Back
            </button>
            <button
              v-if="is_view === false && draftId && draftId !== ''"
              type="button"
              v-on:click="onDeleteDraft"
              class="btn btn-danger"
              :disabled="isLoading"
            >
              <b-spinner small v-if="isLoading"></b-spinner>
              <i v-else class="bx bx-trash" />
              Delete
            </button>
          </div>
          <div class="col-8 text-right" v-if="is_view === false">
            <!-- <button type="button" class="btn btn-info">Preview</button> -->
            <button
              type="button"
              v-on:click="onSaveDraft"
              class="btn btn-primary"
              :disabled="isLoading"
            >
              <b-spinner small v-if="isLoading"></b-spinner>
              <i v-else class="bx bx-save" />
              Save Draft
            </button>
            <button
              type="button"
              v-on:click="onSendToApprove"
              class="btn btn-send-approve"
              :disabled="isLoading"
            >
              <b-spinner small v-if="isLoading"></b-spinner>
              <i v-else class="bx bx-user-check" />
              Send to Approve
            </button>
            <button
              type="button"
              v-on:click="onReset"
              :disabled="isLoading"
              class="btn btn-light"
            >
              <i class="bx bx-reset" />
              Reset
            </button>
          </div>
        </div>
      </div>
      <!-- navigation -->
      <nav
        aria-label="Secondary navigation"
        class="col-xl-2 col-lg-3 col-md-3 d-none d-sm-none d-md-block"
      >
        <ul
          class="nav section-nav flex-column product-resigter-navigation"
          :class="{ fixed: fixedPosition }"
        >
          <li
            class="nav-item mb-2"
            :class="{ active: refActive === 'NewProductInformation' }"
            v-if="is_view && product_register_draft_id"
          >
            <span @click="scrollToRef('NewProductInformation')">{{
              'New Product Information'
            }}</span>
          </li>
          <li
            v-for="(list, index) in navigationListByUserType"
            :key="index"
            class="nav-item mb-2"
            :class="{ active: refActive === list.ref }"
          >
            <span @click="scrollToRef(list.ref)">{{ list.text }}</span>
            <ul
              v-if="
                GET_NAV_PRODUCT_DETAIL.length > 0 &&
                  list.text === 'Product Detail' &&
                  registerOperatorModel.productDetailComponentModel
                    .collapseState &&
                  registerOperatorModel.productDetailComponentModel.model.skus
                    .length > 0
              "
              class="nav section-nav flex-column product-resigter-navigation sub-branch"
            >
              <li
                v-for="(sublist, index) in GET_NAV_PRODUCT_DETAIL"
                :key="index"
                class="nav-item"
                :class="[
                  { 'mb-2': GET_NAV_PRODUCT_DETAIL.length - 1 !== index },
                  {
                    active: index === refActiveIndex && refActive === list.ref,
                  },
                ]"
                @click="refActiveIndex = index"
              >
                <!-- :class="{active: sublist.collapseState && refActive === list.ref}" -->
                <span @click="onClickedNav(sublist, true)">{{
                  sublist.text
                }}</span>
                <i
                  @click="onClickedNav(sublist, !sublist.collapseState)"
                  v-if="list.text === 'Product Detail'"
                  :class="
                    sublist.collapseState
                      ? 'bx bx-chevron-down'
                      : 'bx bx-chevron-left'
                  "
                ></i>
                <ul
                  v-if="sublist.subnav.length > 0 && sublist.collapseState"
                  class="nav section-nav flex-column product-resigter-navigation sub-branch mt-2"
                >
                  <template v-for="(sub2list, index) in sublist.subnav">
                    <li
                      v-if="
                        userInfo.user_type === 'Operator'
                          ? true
                          : sub2list.isVendorVisible
                      "
                      :key="index"
                      class="nav-item"
                      @click="
                        () => {
                          onClickedSubNav(sub2list, !sub2list.collapseState)
                        }
                      "
                      :class="[
                        {
                          active:
                            refActiveDetail === sub2list.ref &&
                            refActive === list.ref,
                        },
                        { 'mb-2': sublist.subnav.length - 1 !== index },
                      ]"
                    >
                      <!-- refActive = sub2list.ref -->
                      <span>{{ sub2list.text }}</span>
                    </li>
                  </template>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>
    <b-modal
      v-model="isModalConfirmShow"
      title="ต้องการส่งอนุมัติเอกสารใช่หรือไม่?"
    >
      <template #default="{ hide }">
        <b-form-textarea
          v-model="textCommentConfirm"
          placeholder="ใส่หมายเหตุเพิ่มเติม"
          rows="6"
          max-rows="6"
        ></b-form-textarea>
      </template>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button
          variant="primary"
          @click.once="createApproveProductRegisterAsync(textCommentConfirm)"
        >
          <i class="bx bx-save"></i> Send to Approve
        </b-button>
      </template>
    </b-modal>
    <!-- end row -->
  </div>
</template>
<script>
import Vue from 'vue'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { eventBus } from '@/main.js'
import productService from '@/helpers/service/product-service'
import productRegisterService from '@/helpers/service/product-register-service'
import warehouseService from '@/helpers/service/warehouse-service'

import { getUserInfo } from '@/helpers/utils/jwt'
import { authComputed } from '@/state/helpers'

import {
  navProductDetailComputed,
  navProductDetailMethods,
} from '@/state/helpers'

//section components
import VendorComponent from '@/components/product-register/sections/vendor'
import BasicComponent from '@/components/product-register/sections/basic'
import ImageComponent from '@/components/product-register/sections/image'
import ProductContentComponent from '@/components/product-register/sections/content'
import AttributeComponent from '@/components/product-register/sections/attribute'
import ShipmentComponent from '@/components/product-register/sections/shipment'
import PaymentMethodComponent from '@/components/product-register/sections/payment-method'
import ChannelComponent from '@/components/product-register/sections/channel'
// import ClusterComponent from '@/components/product-register/sections/cluster'
// import CatalogComponent from '@/components/product-register/sections/catalog'
import InventoryComponent from '@/components/product-register/sections/inventory'
import OtherComponent from '@/components/product-register/sections/other'
import DocumentComponent from '@/components/product-register/sections/document'
import ProductDetailComponent from '@/components/product-register/sections/product-detail'
import brandService from '@/helpers/service/brand-service'
import productRegisterDraftService from '@/helpers/service/product-register-draft-service'
import vendorService from '@/helpers/service/vendor-service'
import NewProductInformation from '../../../components/product-register/sections/new-product-information.vue'
/**
 * Add-product component
 */
export default {
  page: {
    title: 'Register Product',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    PageHeader,
    VendorComponent,
    BasicComponent,
    ImageComponent,
    ProductContentComponent,
    AttributeComponent,
    ShipmentComponent,
    PaymentMethodComponent,
    ChannelComponent,
    InventoryComponent,
    OtherComponent,
    DocumentComponent,
    ProductDetailComponent,
    NewProductInformation,
  },
  data() {
    return {
      status: '',
      registerOperatorModel: {
        vendorComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            id: '',
            code: '',
            display_name: { en: '', th: '' },
            vendor_type: '',
            vendor_status: '',
            lead_time: 0,
            is_import: false,
            is_consignment: false,
            discount_rate_1: 0.0,
            vat_rate: 0,
          },
        },
        basicComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            categories: [
              {
                type: 'Hybrid',
                id: '',
                parent_id: '',
                level: '',
                code: '',
                display_name: { en: '', th: '' },
                parent_categories: [],
              },
              {
                type: 'Inventory',
                id: '',
                parent_id: '',
                level: '',
                code: '',
                display_name: { en: '', th: '' },
                parent_categories: [],
              },
              {
                type: 'JDA',
                id: '',
                parent_id: '',
                level: '',
                code: '',
                display_name: { en: '', th: '' },
                parent_categories: [],
              },
              {
                type: 'Online',
                id: '',
                parent_id: '',
                level: '',
                code: '',
                display_name: { en: '', th: '' },
                parent_categories: [],
              },
            ],
            oracle_code: '',
            gp_standard: 0.0,
            is_best_deal: false,
            brand: { id: '', display_name: { en: '', th: '' } },
            series: { id: '', display_name: { en: '', th: '' } },
            product_names: [
              {
                type: 'Vendor',
                display_name: { en: '', th: '' },
              },
              {
                type: 'PIM',
                display_name: { en: '', th: '' },
              },
            ],
          },
        },
        productDetailComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            sku_mechanics: [
              {
                id: '',
                display_name: { en: '', th: '' },
                type: '',
                collection: '',
                values: [
                  {
                    id: '',
                    display_name: { en: '', th: '' },
                    color_code: '',
                    images: [],
                    type: '',
                    collection: '',
                  },
                ],
                option_values: [],
              },
              {
                id: '',
                display_name: { en: '', th: '' },
                type: '',
                collection: '',
                values: [
                  {
                    id: '',
                    display_name: { en: '', th: '' },
                    color_code: '',
                    images: [],
                    type: '',
                    collection: '',
                  },
                ],
                option_values: [],
              },
              {
                id: '',
                display_name: { en: '', th: '' },
                type: '',
                collection: '',
                values: [
                  {
                    id: '',
                    display_name: { en: '', th: '' },
                    color_code: '',
                    images: [],
                    type: '',
                    collection: '',
                  },
                ],
                option_values: [],
              },
              {
                id: '',
                display_name: { en: '', th: '' },
                type: '',
                collection: '',
                values: [
                  {
                    id: '',
                    display_name: { en: '', th: '' },
                    color_code: '',
                    images: [],
                    type: '',
                    collection: '',
                  },
                ],
                option_values: [],
              },
            ],
            skus: [],
          },
        },
        imageComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: [],
        },
        productContentComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            short_description: { en: '', th: '' },
            long_description: { en: '', th: '' },
            url: [],
          },
        },
        attributeComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            id: '',
            display_name: { en: '', th: '' },
            attributes: [],
          },
        },
        shipmentComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            delivery_time: '',
            dimensions: [],
          },
        },
        paymentMethodComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: [],
        },
        channelComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          isUpdatedByUser: false,
          model: [],
        },
        clusterComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: { cluster_group: '' },
        },
        catalogComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: [],
        },
        inventoryComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            warehouse_for_goods_received: {
              warehouse_id: '',
              warehouse_name: '',
              sub_warehouses: {
                sub_warehouse_id: '',
                sub_warehouse_name: '',
                order_type: '',
              },
            },
          },
        },
        otherComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          model: {
            is_consignment: false,
            has_new_product_fee: false,
            is_return_to_vendor: false,
            aging: '0',
            is_import: false,
            is_own_brand: false,
            is_bidding_price: false,
            is_preorder: false,
            is_available_stock: false,
            is_free: false,
            type: '',
            is_hamper: false,
            has_consumer_protection: true,
            vendor_remark: '',
            product_remark: '',
            is_delivery_restriction: false,
            pre_order_end_date: '',
            pre_order_start_date: '',
            is_virtual_stock: false,
          },
        },
        documentComponentModel: {
          collapseState: false,
          validateState: false,
          isPayloadChanged: false,
          fileDocuments: [],
        },
      },

      title: 'Register Product',
      prevScroll: 0,
      items: [
        {
          text: 'Product Register Information',
          href: '/product/registers',
        },
        {
          text: 'Register Product',
          active: true,
        },
      ],
      list: [
        { name: 'John', id: 0 },
        { name: 'Joao', id: 1 },
        { name: 'Jean', id: 2 },
      ],
      // drag
      fixedPosition: false,
      refActive:
        this.is_view && this.product_register_draft_id
          ? 'NewProductInformation'
          : 'VendorInformation',
      preventScroll: false,
      navigationLists: [
        {
          ref: 'VendorInformation',
          text: 'Vendor Information',
          collapse: 'vendor',
        },
        {
          ref: 'BasicInformation',
          text: 'Basic Information',
          collapse: 'basic',
        },
        {
          ref: 'ProductDetailComponent',
          text: 'Product Detail',
          collapse: 'product-detail',
        },
        { ref: 'ImageManagement', text: 'Image Management', collapse: 'image' },
        {
          ref: 'ProductContentComponent',
          text: 'Product Content',
          collapse: 'product-content',
        },
        {
          ref: 'ProductAttribute',
          text: 'Product Attribute',
          collapse: 'attribute',
        },
        {
          ref: 'ShipmentDetail',
          text: 'Shipment Detail',
          collapse: 'shipment',
        },
        { ref: 'PaymentMethod', text: 'Payment Method', collapse: 'payment' },
        { ref: 'Channel', text: 'Channel', collapse: 'channel' },
        // { ref: 'Cluster', text: 'Cluster', collapse: 'cluster' },
        // { ref: 'Catalog', text: 'Catalog', collapse: 'catalog' },
        { ref: 'Inventory', text: 'Inventory', collapse: 'inventory' },
        { ref: 'OtherSetting', text: 'Other Setting', collapse: 'other' },
        { ref: 'Document', text: 'Document', collapse: 'document' },
      ],
      product_register_draft_id: '',
      refActiveDetail: '',
      refActiveIndex: null,
      isModalConfirmShow: false,
      textCommentConfirm: null,
      isLoading: false,
      isSelectedChannelByUser: false,
      collapseStateNewProductInformation: true,
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    if (window.scrollY > 40) this.fixedPosition = true

    if (this.$route.params.id && this.$route.params.id !== '') {
      this.product_register_draft_id = this.$route.params.id
      this.getProductRegisterDraft(this.$route.params.id)
    }
    eventBus.$on('onSetDefault', fieldChange => {
      console.log('fieldChange', fieldChange)
      if (
        fieldChange.type === 'Product Type' ||
        fieldChange.type === 'Status'
      ) {
        this.setDefaultShipmentDeliveryTime()
        this.setDefaultChannel()
      }
      if (fieldChange.type === 'Product Type') {
        this.setDefaultInventoryWarehouseAndSubWarehouse()
      }
      console.log('Product Type')
    })
  },
  async mounted() {
    if (window.scrollY > 40) this.fixedPosition = true
    if (this.$route.params.id && this.$route.params.id !== '') {
      this.product_register_draft_id = this.$route.params.id
      await this.getProductRegisterDraft(this.$route.params.id)
      //
    }
    this.refActive =
      this.is_view && this.product_register_draft_id
        ? 'NewProductInformation'
        : 'VendorInformation'
  },
  computed: {
    ...authComputed,
    ...navProductDetailComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    navigationListByUserType() {
      let dropShipList = [
        'VendorInformation',
        'BasicInformation',
        'ProductDetailComponent',
        'ImageManagement',
        'ProductContentComponent',
        'ProductAttribute',
        'ShipmentDetail',
        'OtherSetting',
        'Document',
      ]
      return this.userInfo.user_type === 'Operator'
        ? this.navigationLists
        : this.navigationLists.filter(f => dropShipList.some(s => s === f.ref))
    },
    is_view() {
      if (
        (this.$route.query &&
          this.$route.query.mode &&
          this.$route.query.mode === 'view') ||
        this.status === 'Pending'
      ) {
        return true
      }
      return false
    },
    is_free() {
      if (
        (this.$route.query &&
          this.$route.query.mode &&
          this.$route.query.mode === 'free') ||
        this.registerOperatorModel.otherComponentModel.model.is_free
      ) {
        return true
      }
      return false
    },
    is_draft() {
      if (
        this.$route.query &&
        this.$route.query.mode &&
        this.$route.query.mode === 'draft'
      ) {
        return true
      }
      return false
    },
    draftId() {
      if (this.product_register_draft_id !== '') {
        return this.product_register_draft_id
      } else if (this.$route.params.id !== '') {
        return this.$route.params.id
      } else {
        return this.product_register_draft_id
      }
    },
    product_status_inventory() {
      const skus = this.registerOperatorModel.productDetailComponentModel.model
        .skus
      if (skus[0]) {
        return skus[0].skuModel.product_status.inventory
      }
      return null
    },
  },
  watch: {
    // 'registerOperatorModel.vendorComponentModel.model.vendor_type': {
    //   handler(newValue, oldValue) {
    //     // Note: `newValue` will be equal to `oldValue` here
    //     // on nested mutations as long as the object itself
    //     // hasn't been replaced.
    //     if (newValue !== oldValue) {
    //       this.setDefaultShipmentDeliveryTime()
    //       this.setDefaultInventoryWarehouseAndSubWarehouse()
    //       this.setDefaultChannel()
    //     }
    //   },
    //   deep: true,
    // },
    // product_status_inventory: {
    //   handler(newValue, oldValue) {
    //     // Note: `newValue` will be equal to `oldValue` here
    //     // on nested mutations as long as the object itself
    //     // hasn't been replaced.
    //     if (newValue !== oldValue) {
    //       this.setDefaultShipmentDeliveryTime()
    //       this.setDefaultChannel()
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    ...navProductDetailMethods,
    onBack() {
      this.$router.push({
        path: '/product/registers',
      })
    },
    handleScroll() {
      if (window.scrollY > 40) {
        this.fixedPosition = true
      } else {
        this.fixedPosition = false
      }

      if (this.prevScroll < window.scrollY && !this.preventScroll) {
        this.navigationListByUserType.forEach(element => {
          if (window.scrollY >= this.$refs[element.ref].offsetTop + 30) {
            this.refActive = element.ref
          }
        })
      } else if (this.prevScroll > window.scrollY && !this.preventScroll) {
        // if (window.scrollY >= 0) {
        //   this.refActive = 'VendorInformation'
        // }
        this.navigationListByUserType.forEach(element => {
          if (
            window.scrollY >=
              this.$refs[element.ref].offsetTop -
                this.$refs[element.ref].clientHeight &&
            window.scrollY >= this.$refs[element.ref].offsetTop - 120
          ) {
            this.refActive = element.ref
          }
        })
      }
      this.prevScroll = window.scrollY
    },
    scrollToRef(refName) {
      var top = this.$refs[refName].offsetTop + 30
      //this.collapseStates[refName] = true
      switch (refName) {
        case 'VendorInformation':
          this.registerOperatorModel.vendorComponentModel.collapseState = true
          break
        case 'NewProductInformation':
          this.collapseStateNewProductInformation = true
          break
        case 'BasicInformation':
          this.registerOperatorModel.basicComponentModel.collapseState = true
          break
        case 'ProductDetailComponent':
          this.registerOperatorModel.productDetailComponentModel.collapseState = true
          break
        case 'ImageManagement':
          this.registerOperatorModel.imageComponentModel.collapseState = true
          break
        case 'ProductContentComponent':
          this.registerOperatorModel.productContentComponentModel.collapseState = true
          break
        case 'ProductAttribute':
          this.registerOperatorModel.attributeComponentModel.collapseState = true
          break
        case 'ShipmentDetail':
          this.registerOperatorModel.shipmentComponentModel.collapseState = true
          break
        case 'PaymentMethod':
          this.registerOperatorModel.paymentMethodComponentModel.collapseState = true
          break
        case 'Channel':
          this.registerOperatorModel.channelComponentModel.collapseState = true
          break
        case 'Cluster':
          this.registerOperatorModel.clusterComponentModel.collapseState = true
          break
        case 'Catalog':
          this.registerOperatorModel.catalogComponentModel.collapseState = true
          break
        case 'Inventory':
          this.registerOperatorModel.inventoryComponentModel.collapseState = true
          break
        case 'OtherSetting':
          this.registerOperatorModel.otherComponentModel.collapseState = true
          break
        case 'Document':
          this.registerOperatorModel.documentComponentModel.collapseState = true
          break
      }
      this.refActive = refName
      window.scroll({
        behavior: 'smooth',
        top: top,
      })
      this.preventScroll = true
      setTimeout(() => {
        this.preventScroll = false
      }, 800)
    },
    async onGetVendorByIdAsync(id) {
      let result = await vendorService.getVendorMasterDetailAsync(id)
      if (result.status === 200) {
        if (result.data) {
          let vendorData = result.data
          if (vendorData.status == 'Active' || vendorData.status == 'Suspend') {
            this.registerOperatorModel.vendorComponentModel.model.id =
              vendorData.id
            this.registerOperatorModel.vendorComponentModel.model.display_name =
              vendorData.display_name
            this.registerOperatorModel.vendorComponentModel.model.vendor_type =
              vendorData.type
            this.registerOperatorModel.vendorComponentModel.model.vendor_status =
              vendorData.status
            this.registerOperatorModel.vendorComponentModel.model.lead_time =
              vendorData.lead_time
            this.registerOperatorModel.vendorComponentModel.model.is_consignment =
              vendorData.is_consignment
            this.registerOperatorModel.vendorComponentModel.model.is_import =
              vendorData.is_import
            this.registerOperatorModel.vendorComponentModel.model.discount_rate_1 =
              vendorData.discount.rate_1
            this.registerOperatorModel.vendorComponentModel.model.code = vendorData.vendor_partners.find(
              f => f.partner === 'OFM'
            ).code
            this.registerOperatorModel.vendorComponentModel.model.vat_rate =
              vendorData.vat_rate
          }
        }
      } else {
        console.log('error', result.response.data.message)
      }
    },
    async getProductRegisterDraft(id) {
      this.isLoading = true
      let result = await productRegisterDraftService.getProductRegisterDraftByIdAsync(
        id
      )
      if (result.status === 200) {
        await this.onGetVendorByIdAsync(result.data.vendor_information.id)
        let brandMaster = await brandService.getBrandMasterDetailAsync(
          result.data.brand.id
        )
        this.status = result.data.status
        this.registerOperatorModel.basicComponentModel.model.categories =
          result.data.categories
        this.registerOperatorModel.basicComponentModel.model.brand =
          brandMaster.status === 200
            ? {
                id: brandMaster.data.id,
                display_name: brandMaster.data.display_name,
                is_own_brand: brandMaster.data.is_own_brand,
              }
            : {
                id: result.data.brand.id,
                display_name: result.data.brand.display_name,
                is_own_brand: result.data.other.is_own_brand,
              }
        this.registerOperatorModel.basicComponentModel.model.series =
          result.data.series
        this.registerOperatorModel.basicComponentModel.model.product_names =
          result.data.product_names
        this.registerOperatorModel.basicComponentModel.model.business_unit =
          result.data.business_unit != null ? result.data.business_unit : []
        this.registerOperatorModel.productDetailComponentModel.model.sku_mechanics =
          result.data.product_detail.sku_mechanics
        this.registerOperatorModel.productDetailComponentModel.model.skus = result.data.product_detail.skus.map(
          (element, index) => {
            return {
              index: index + 1,
              validateState: false,
              successRate: '',
              skuModel: {
                sku_code_ofm: element.sku_code_ofm,
                product_names: element.product_names.map(s => {
                  return {
                    type: s.type,
                    display_name: s.display_name,
                    isDefault: false,
                  }
                }),
                meta: {
                  title_tag: element.meta.title_tag,
                  description_tag: element.meta.description_tag,
                  keyword: element.meta.keyword,
                  cononical_tag: element.meta.cononical_tag,
                  robot: element.meta.robot,
                  sitemap_priority: element.meta.sitemap_priority,
                  seo_name: element.meta.seo_name
                    ? element.meta.seo_name
                    : { en: '', th: '' },
                  is_default: [false, false, false, false],
                },
                prices: element.prices,
                gross_profit: element.gross_profit
                  ? element.gross_profit
                  : {
                      gp_standard: 0.0,
                      gp_rate: 0,
                      gp_amount: 0.0,
                      cost_of_sale: 0.0,
                      isGPBelow5Percent: false,
                    },
                product_status: element.product_status,
                mechanics: element.mechanics,
                sku_codes: element.sku_codes,
                barcodes: element.barcodes,
                quantity: element.quantity,
                other: element.other,
                unit: element.unit,
                jda: element.jda,
                substitute_input: {
                  sku_id: '',
                  product_id: '',
                  product_name: { en: '', th: '' },
                  product_status: { vendor: '', inventory: '', sale: '' },
                },
                substitutes: element.substitutes ? element.substitutes : [],
                substitutes_to: element.substitutes_to
                  ? element.substitutes_to
                  : [],
              },
            }
          }
        )
        this.registerOperatorModel.productContentComponentModel.model =
          result.data.content
        this.registerOperatorModel.attributeComponentModel.model =
          result.data.attribute
        this.registerOperatorModel.paymentMethodComponentModel.model =
          result.data.payments
        this.registerOperatorModel.shipmentComponentModel.model =
          result.data.shipment
        this.registerOperatorModel.otherComponentModel.model = result.data.other
        this.registerOperatorModel.catalogComponentModel.model =
          result.data.catalogs
        this.registerOperatorModel.channelComponentModel.model =
          result.data.channels
        this.registerOperatorModel.clusterComponentModel.model =
          result.data.cluster
        this.registerOperatorModel.inventoryComponentModel.model =
          result.data.inventory
        this.registerOperatorModel.documentComponentModel.fileDocuments =
          result.data.files
        this.$nextTick(() => {
          this.registerOperatorModel.imageComponentModel.model =
            result.data.image_managements
          this.isLoading = false
        })
        this.product_register_draft_id = result.data.id

        this.registerOperatorModel.productDetailComponentModel.model.skus.forEach(
          item => {
            console.log('productDetailComponentModel', item)
            if (
              !item.skuModel.sku_codes.some(w => w.type.toUpperCase() == 'B2S')
            ) {
              var sku_code = { type: 'B2S', code: '' }
              item.skuModel.sku_codes.push(sku_code)
            }
          }
        )
      }
    },
    async validateBeforeSaveDraft(productModel) {
      let messageError = []
      if (
        productModel.categories === null ||
        (productModel.categories && productModel.categories.length === 0) ||
        productModel.categories.find(f => f.type === 'Hybrid').id === ''
      ) {
        messageError.push('โปรดระบุข้อมูลหมวดหมู่ในส่วนของ Basic Information')
      }
      // if (productModel.brand === null || productModel.brand.id === '') {
      //   messageError.push('โปรดระบุข้อมูล Brand ในส่วนของ Basic Information')
      // }
      // if (productModel.series === null || productModel.series.id === '') {
      //   messageError.push('โปรดระบุข้อมูล Series ในส่วนของ Basic Information')
      // }
      if (
        productModel.product_detail === null ||
        productModel.product_detail.skus === null ||
        (productModel.product_detail.skus &&
          productModel.product_detail.skus.length === 0)
      ) {
        messageError.push('โปรด Generate SKU ในส่วนของ Product Detail')
      }
      // if (productModel.attribute === null || productModel.attribute.id === '') {
      //   messageError.push(
      //     'โปรดระบุข้อมูล Attribute ในส่วนของ Product Attribute'
      //   )
      // }
      if (messageError.length > 0) {
        this.$utils.notificationAck(
          'error',
          'ไม่สามารถดำเนินการได้',
          messageError.join(', ') + ' ก่อนทำการ Save Draft'
        )
        return false
      } else {
        return true
      }
    },
    async onSaveDraft() {
      await this.$utils
        .confirmAlertDisplay(`ต้องการ Save Draft ใช่หรือไม่?`, '')
        .then(async resultConfirm => {
          if (resultConfirm) {
            await this.updateProductRegisterDraftAsync()
          }
        })
    },
    async updateProductRegisterDraftAsync() {
      let productModel = await this.mappingProductRegisterDataAsync()
      if (await this.validateBeforeSaveDraft(productModel)) {
        let jsonString = JSON.stringify(productModel)
        let utf8EncodedString = unescape(encodeURIComponent(jsonString))
        let objBase64 = btoa(utf8EncodedString)
        let dataPayload = new FormData()
        dataPayload.append('payload_base64', objBase64)

        let result = await productRegisterDraftService.updateProductRegisterDraftAsync(
          dataPayload
        )
        if (result.status === 201) {
          this.$utils.notification('success', 'บันทึกสำเร็จ', 1500)
          this.$utils.notificationAck(
            'success',
            'บันทึกสำเร็จ',
            `เอกสาร Draft เลขที่ ${result.data}`
          )
          this.$nextTick(() => {
            // this.$router.push({
            //   name: 'register-product-draft',
            //   params: { id: result.data },
            //   query: {
            //     mode: 'draft',
            //   },
            // })
            //
            console.log('isFirstLoad this.$route.name', this.$route.name)
            if (this.$route.name != 'register-product-draft') {
              window.location.href = `/products/register/${result.data}?mode=draft`
            }
          })
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          this.$utils.notificationAck(
            'error',
            'ไม่สามารถดำเนินการได้',
            result.response.data.message
          )
        }
      }
    },
    async onDeleteDraft() {
      await this.$utils
        .confirmAlertDisplay(`ต้องปรับสถานะเอกสารเป็น Delete ใช่หรือไม่?`, '')
        .then(async resultConfirm => {
          if (resultConfirm) {
            await this.deleteProductRegisterDraftByIdAsync()
          }
        })
    },
    async deleteProductRegisterDraftByIdAsync() {
      let result = await productRegisterDraftService.deleteProductRegisterDraftByIdAsync(
        this.product_register_draft_id
      )
      if (result.status && result.status === 204) {
        this.$utils.notificationAck(
          'success',
          'ดำเนินการสำเร็จ',
          `เอกสาร Draft ${this.product_register_draft_id} ถูกปรับเป็นสถานะ Delete`
        )
        this.$nextTick(() => {
          this.$router.push({
            path: `/product/registers`,
          })
        })
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notificationAck(
          'error',
          'ไม่สามารถดำเนินการได้',
          result.response.data.message
        )
      }
    },
    async onSendToApprove() {
      if (this.registerOperatorModel) {
        this.checkValidateAllComponent()
        // this.$refs.ProductDetail.$refs.table_product_detail.reCalculate() //recal product price cost
        setTimeout(async () => {
          if (this.checkComponentValidateState()) {
            this.isModalConfirmShow = true
            /*  Vue.swal
              .fire({
                title: 'ต้องการส่งอนุมัติเอกสารใช่หรือไม่?',
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'ใส่หมายเหตุเพิ่มเติม',
                inputAttributes: {
                  'aria-label': 'ใส่หมายเหตุเพิ่มเติม',
                },
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonText: '<i class="bx bx-save"></i> Send to Approve',
                cancelButtonText: 'Close',
              })
              .then(async result => {
                if (result.isConfirmed === true) {
                  await this.createApproveProductRegisterAsync(result.value)
                }
              }) */

            // if (text) {
            // await this.createApproveProductRegisterAsync(text)
            // }

            // await this.$utils
            //   .confirmAlertDisplay(`ต้องการ Send to approve ใช่หรือไม่?`, '')
            //   .then(async resultConfirm => {
            //     if (resultConfirm) {
            //       await this.createApproveProductRegisterAsync()
            //     }
            //   })
          }
        }, 1000)
      }
    },
    async mappingProductRegisterDataAsync() {
      let productModel = {
        id: this.draftId && this.draftId !== '' ? this.draftId : '',
        product_id: '',
        categories: this.registerOperatorModel.basicComponentModel.model
          .categories,
        brand: this.registerOperatorModel.basicComponentModel.model.brand,
        series: this.registerOperatorModel.basicComponentModel.model.series,
        product_names: this.registerOperatorModel.basicComponentModel.model
          .product_names,
        vendor_information: this.registerOperatorModel.vendorComponentModel
          .model,
        product_detail: {
          sku_mechanics: this.registerOperatorModel.productDetailComponentModel.model.sku_mechanics.filter(
            f => f.id !== ''
          ),
          skus: this.registerOperatorModel.productDetailComponentModel.model.skus.map(
            (element, index) => {
              return {
                sku_code_ofm: element.skuModel.sku_code_ofm,
                product_names: element.skuModel.product_names,
                meta: element.skuModel.meta,
                prices: element.skuModel.prices,
                product_status: element.skuModel.product_status,
                mechanics: element.skuModel.mechanics,
                sku_codes: element.skuModel.sku_codes,
                barcodes: element.skuModel.barcodes,
                quantity: element.skuModel.quantity,
                other: element.skuModel.other,
                unit: element.skuModel.unit,
                jda: element.skuModel.jda,
                substitutes: element.skuModel.substitutes,
                substitutes_to: element.skuModel.substitutes_to,
                gross_profit: element.skuModel.gross_profit,
              }
            }
          ),
        },
        image_managements: this.registerOperatorModel.imageComponentModel.model.map(
          item => {
            return {
              sku_id: item.sku_id,
              is_default_color: item.is_default_color,
              images: item.images.map((image, index) => {
                return {
                  sequence: index + 1,
                  size: image.size,
                  url: image.url,
                  //  cdn_url: image.cdn_url,
                }
              }),
            }
          }
        ),
        content: this.registerOperatorModel.productContentComponentModel.model,
        attribute: this.registerOperatorModel.attributeComponentModel.model,
        payments: this.registerOperatorModel.paymentMethodComponentModel.model,
        shipment: this.registerOperatorModel.shipmentComponentModel.model,
        other: this.registerOperatorModel.otherComponentModel.model,
        catalogs: this.registerOperatorModel.catalogComponentModel.model,
        channels: this.registerOperatorModel.channelComponentModel.model,
        cluster: this.registerOperatorModel.clusterComponentModel.model,
        inventory: this.registerOperatorModel.inventoryComponentModel.model,
        files: this.registerOperatorModel.documentComponentModel.fileDocuments,
        product_register_draft_id:
          this.draftId && this.draftId !== '' ? this.draftId : '',
        business_unit: this.registerOperatorModel.basicComponentModel.model
          .business_unit,
      }
      return productModel
    },
    async createApproveProductRegisterAsync(remark) {
      let productModel = await this.mappingProductRegisterDataAsync()
      productModel.request_remark = remark

      let jsonString = JSON.stringify(productModel)
      let utf8EncodedString = unescape(encodeURIComponent(jsonString))
      let objBase64 = btoa(utf8EncodedString)
      let dataPayload = new FormData()
      dataPayload.append('payload_base64', objBase64)

      let result = await productRegisterService.createApproveProductRegisterAsync(
        dataPayload
      )
      if (result.status === 201) {
        this.$utils.notificationAck(
          'success',
          'เพิ่มข้อมูลสำเร็จ',
          `สร้างเอกสารเลขที่ <a href='/products/request/${result.data.id}/product-register' >${result.data.id} </a> สำเร็จ`
        )
        // this.$router.push({
        //   path: `/products/request/${result.data.id}/product-register`,
        // })
        window.location.href = `/products/request/${result.data.id}/product-register`
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notificationAck(
          'error',
          'ไม่สามารถดำเนินการได้',
          result.data.message
        )
        this.isModalConfirmShow = false
      }
    },
    checkComponentValidateState() {
      let isDone = true
      if (
        this.registerOperatorModel.vendorComponentModel.validateState === false
      ) {
        isDone = this.moveToCollapse('vendor')
      } else if (
        this.registerOperatorModel.basicComponentModel.validateState === false
      ) {
        isDone = this.moveToCollapse('basic')
      } else if (
        this.registerOperatorModel.productDetailComponentModel.validateState ===
        false
      ) {
        isDone = this.moveToCollapse('product-detail')
      } else if (
        this.registerOperatorModel.imageComponentModel.validateState === false
      ) {
        isDone = this.moveToCollapse('image')
      } else if (
        this.registerOperatorModel.productContentComponentModel
          .validateState === false
      ) {
        isDone = this.moveToCollapse('product-content')
      } else if (
        this.registerOperatorModel.attributeComponentModel.validateState ===
        false
      ) {
        isDone = this.moveToCollapse('attribute')
      } else if (
        this.registerOperatorModel.shipmentComponentModel.validateState ===
        false
      ) {
        isDone = this.moveToCollapse('shipment')
      } else if (
        this.registerOperatorModel.paymentMethodComponentModel.validateState ===
          false &&
        this.userInfo.user_type === 'Operator'
      ) {
        isDone = this.moveToCollapse('payment')
      } else if (
        this.registerOperatorModel.channelComponentModel.validateState ===
          false &&
        this.userInfo.user_type === 'Operator'
      ) {
        isDone = this.moveToCollapse('channel')
      }
      // else if (
      //   this.registerOperatorModel.clusterComponentModel.validateState ===
      //     false &&
      //   this.userInfo.user_type === 'Operator'
      // )
      // {
      //   isDone = this.moveToCollapse('cluster')
      // }
      // else if (
      //   this.registerOperatorModel.catalogComponentModel.validateState ===
      //     false &&
      //   this.userInfo.user_type === 'Operator'
      // ) {
      //   isDone = this.moveToCollapse('catalog')
      // }
      else if (
        this.registerOperatorModel.inventoryComponentModel.validateState ===
          false &&
        this.userInfo.user_type === 'Operator'
      ) {
        isDone = this.moveToCollapse('inventory')
      } else if (
        this.registerOperatorModel.otherComponentModel.validateState ===
          false &&
        this.userInfo.user_type === 'Operator'
      ) {
        isDone = this.moveToCollapse('other')
      } else if (
        this.registerOperatorModel.documentComponentModel.validateState ===
        false
      ) {
        isDone = this.moveToCollapse('document')
      }
      return isDone
    },
    checkValidateAllComponent() {
      this.navigationListByUserType.forEach(element => {
        eventBus.$emit(`collapse-${element.collapse}`, true)
      })
    },
    moveToCollapse(componentName) {
      document.getElementById(`header-${componentName}`).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
      eventBus.$emit(`collapse-${componentName}`, true)
      return false
    },
    onReset() {
      location.reload()
    },
    onClickedNav(item, collapseState) {
      eventBus.$emit('nav-product-detail-set-collapse-state', {
        collapseState,
        item,
      })
      this.refActive = item.ref
    },
    onClickedSubNav(item, collapseState) {
      eventBus.$emit('sub-nav-product-detail-set-collapse-state', {
        item,
        collapseState,
      })
    },
    ref_active_detail(data) {
      // console.log(data)
      this.refActiveDetail = data.ref
      this.refActiveIndex = data.index
    },
    setDefaultShipmentDeliveryTime() {
      const defaultShipmentDeliveryTimeOption = [
        {
          vendor_type: 'OFMStock',
          product_status: 'Stock',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'Limited',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'NonStock',
          delivery_time: '7-15',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'PreOrder',
          delivery_time: '7-15',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'Free',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'New',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'ByOrder',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'Control',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'Special',
          delivery_time: '1-3',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'InStore',
          delivery_time: '7-15',
        },
        {
          vendor_type: 'OFMStock',
          product_status: 'Internal',
          delivery_time: '7-15',
        },
        {
          vendor_type: 'DropShip',
          product_status: 'NonStock',
          delivery_time: '3-7',
        },
      ]

      const vendorType = this.registerOperatorModel.vendorComponentModel.model
        .vendor_type
      const skus = this.registerOperatorModel.productDetailComponentModel.model
        .skus
      // const delivery_time = this.registerOperatorModel.shipmentComponentModel
      //   .model.delivery_time
      // if (delivery_time) {
      //   return
      // }
      if (!vendorType) {
        return
      }
      if (vendorType === 'DropShip') {
        eventBus.$emit('setShipmentOptionForDropShip', true)
      }
      if (
        !skus ||
        skus.length === 0 ||
        !skus[0].skuModel ||
        !skus[0].skuModel.product_status ||
        !skus[0].skuModel.product_status.inventory
      ) {
        return
      }
      const product_status = skus[0].skuModel.product_status.inventory
      const defaultValue = defaultShipmentDeliveryTimeOption.find(
        it =>
          it.vendor_type === vendorType && it.product_status === product_status
      )
      if (defaultValue) {
        const default_delivery_time = defaultValue.delivery_time
        this.registerOperatorModel.shipmentComponentModel.model.delivery_time = default_delivery_time
        console.log(
          'set defaultValue default_delivery_time = ',
          default_delivery_time
        )
      }
      return
    },
    setDefaultInventoryWarehouseAndSubWarehouse() {
      const defaultInventoryWarehouseAndSubWarehouseOption = [
        {
          vendor_type: 'OFMStock',
          warehouse_id: '5',
          warehouse_name: 'คลังสินค้าสุวินทวงค์',
          sub_warehouses: {
            sub_warehouse_id: '50001',
            sub_warehouse_name: 'Main SubWH (Murata)',
            order_type: 'Normal',
          },
        },
        {
          vendor_type: 'DropShip',
          warehouse_id: '5',
          warehouse_name: 'คลังสินค้าสุวินทวงค์',
          sub_warehouses: {
            sub_warehouse_id: '50011',
            sub_warehouse_name: 'Market place-SubWH',
            order_type: 'MKP',
          },
        },
      ]
      const vendorType = this.registerOperatorModel.vendorComponentModel.model
        .vendor_type
      if (!vendorType) {
        return
      }
      // const warehouse_for_goods_received = this.registerOperatorModel
      //   .inventoryComponentModel.model.warehouse_for_goods_received
      // if (warehouse_for_goods_received) {
      //   return
      // }
      const default_warehouse_for_goods_received = defaultInventoryWarehouseAndSubWarehouseOption.find(
        it => it.vendor_type === vendorType
      )
      console.log(
        'set defaultValue default_warehouse_for_goods_received before= ',
        this.registerOperatorModel.inventoryComponentModel.model
      )
      if (default_warehouse_for_goods_received) {
        delete default_warehouse_for_goods_received.vendor_type
        this.registerOperatorModel.inventoryComponentModel.model.warehouse_for_goods_received = default_warehouse_for_goods_received
        console.log(
          'set defaultValue default_warehouse_for_goods_received = ',
          default_warehouse_for_goods_received
        )
      }
      return
    },
    setDefaultChannel() {
      const defaultChannelOption = [
        {
          vendor_type: 'OFMStock',
          product_statuses: [
            'Stock',
            'Limited',
            'NonStock',
            'PreOrder',
            'Free',
          ],
          model: [
            {
              checkbox: true,
              index: 0,
              id: '1',
              group: 'Offline',
              display_name: {
                en: 'Call Center',
                th: 'Call Center',
              },
            },
            {
              checkbox: true,
              index: 1,
              id: '2',
              group: 'Offline',
              display_name: {
                en: 'OFM Store (OASYS)',
                th: 'OFM Store (OASYS)',
              },
            },
            {
              checkbox: true,
              index: 2,
              id: '3',
              group: 'Offline',
              display_name: {
                en: 'OFM Franchise',
                th: 'OFM Franchise',
              },
            },
            {
              checkbox: true,
              index: 3,
              id: '5',
              group: 'Online',
              display_name: {
                en: 'Online Officemate',
                th: 'Online Officemate',
              },
            },
            {
              checkbox: true,
              index: 4,
              id: '6',
              group: 'Online',
              display_name: {
                en: 'Online OFM',
                th: 'Online OFM',
              },
            },
            {
              checkbox: true,
              index: 5,
              id: '9',
              group: 'Offline',
              display_name: {
                en: 'B2S Store (OASYS)',
                th: 'B2S Store (OASYS)',
              },
            },
            {
              checkbox: true,
              index: 14,
              id: '20',
              group: 'Offline',
              display_name: {
                en: 'Chat and Shop',
                th: 'Chat and Shop',
              },
            },
          ],
        },
        {
          vendor_type: 'OFMStock',
          product_statuses: [
            'New',
            'ByOrder',
            'Control',
            'Special',
            'InStore',
            'Internal',
          ],
          model: [
            {
              checkbox: true,
              index: 0,
              id: '1',
              group: 'Offline',
              display_name: {
                en: 'Call Center',
                th: 'Call Center',
              },
            },
            {
              checkbox: true,
              index: 1,
              id: '2',
              group: 'Offline',
              display_name: {
                en: 'OFM Store (OASYS)',
                th: 'OFM Store (OASYS)',
              },
            },
            {
              checkbox: true,
              index: 2,
              id: '3',
              group: 'Offline',
              display_name: {
                en: 'OFM Franchise',
                th: 'OFM Franchise',
              },
            },
            {
              checkbox: true,
              index: 5,
              id: '9',
              group: 'Offline',
              display_name: {
                en: 'B2S Store (OASYS)',
                th: 'B2S Store (OASYS)',
              },
            },
            {
              checkbox: true,
              index: 14,
              id: '20',
              group: 'Offline',
              display_name: {
                en: 'Chat and Shop',
                th: 'Chat and Shop',
              },
            },
          ],
        },
        {
          vendor_type: 'DropShip',
          product_statuses: ['AllStatus'],
          model: [
            {
              checkbox: true,
              index: 0,
              id: '1',
              group: 'Offline',
              display_name: {
                en: 'Call Center',
                th: 'Call Center',
              },
            },
            {
              checkbox: true,
              index: 1,
              id: '2',
              group: 'Offline',
              display_name: {
                en: 'OFM Store (OASYS)',
                th: 'OFM Store (OASYS)',
              },
            },
            {
              checkbox: true,
              index: 2,
              id: '3',
              group: 'Offline',
              display_name: {
                en: 'OFM Franchise',
                th: 'OFM Franchise',
              },
            },
            {
              checkbox: true,
              index: 3,
              id: '5',
              group: 'Online',
              display_name: {
                en: 'Online Officemate',
                th: 'Online Officemate',
              },
            },
            {
              checkbox: true,
              index: 4,
              id: '6',
              group: 'Online',
              display_name: {
                en: 'Online OFM',
                th: 'Online OFM',
              },
            },
            {
              checkbox: true,
              index: 5,
              id: '9',
              group: 'Offline',
              display_name: {
                en: 'B2S Store (OASYS)',
                th: 'B2S Store (OASYS)',
              },
            },
            {
              checkbox: true,
              index: 14,
              id: '20',
              group: 'Offline',
              display_name: {
                en: 'Chat and Shop',
                th: 'Chat and Shop',
              },
            },
          ],
        },
      ]
      // console.log('isSelectedChannelByUser', this.isSelectedChannelByUser)
      // if (this.isSelectedChannelByUser) {
      //   return
      // }
      // const channel = this.registerOperatorModel.channelComponentModel.model
      // console.log('channel', channel)
      // if (channel && channel.length > 0) {
      //   return
      // }
      const vendorType = this.registerOperatorModel.vendorComponentModel.model
        .vendor_type
      // console.log('vendorType', vendorType)
      if (!vendorType) {
        return
      }
      const skus = this.registerOperatorModel.productDetailComponentModel.model
        .skus
      if (
        !skus ||
        skus.length === 0 ||
        !skus[0].skuModel ||
        !skus[0].skuModel.product_status ||
        !skus[0].skuModel.product_status.inventory
      ) {
        return
      }
      const product_status = skus[0].skuModel.product_status.inventory
      // console.log('product_status', product_status)
      const defaultValue = defaultChannelOption.find(
        it =>
          it.vendor_type === vendorType &&
          it.product_statuses.some(
            it2 => it2 === product_status || it2 === 'AllStatus'
          )
      )
      // console.log('defaultValue', defaultValue)
      if (defaultValue) {
        this.registerOperatorModel.channelComponentModel.model =
          defaultValue.model
        // console.log(
        //   'channelComponentModel',
        //   this.registerOperatorModel.channelComponentModel.model
        // )
        console.log('set defaultValue channel = ', defaultValue.model)
      }
      return
    },
  },
}
</script>
<style></style>
